import React, { memo } from 'react';

import { MoreButtonCDS } from '@sharedCR/coreDesignSystem/Buttons';
import MenuPopoverCDS from '@sharedCR/coreDesignSystem/MenuPopoverCDS';
import PropTypes from 'prop-types';

import usePopover from 'hooks/usePopover';

const defaultItems = [];

const ActionCellButtonCDS = ({ items = defaultItems, isDisabled = false, isHidden = false }) => {
  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  if (isHidden || !items?.length) {
    return null;
  }

  return (
    <>
      <MoreButtonCDS disabled={isDisabled} isSelected={!!anchorEl} onClick={onSetAnchorElement} />

      <MenuPopoverCDS
        anchorEl={anchorEl}
        items={items}
        onClick={onClearAnchorElement}
        onClose={onClearAnchorElement}
      />
    </>
  );
};

ActionCellButtonCDS.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node,
    }),
  ),
  isDisabled: PropTypes.bool,
  isHidden: PropTypes.bool,
};

export default memo(ActionCellButtonCDS);
